import { DiamondNode, DiamondNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class ParallelGatewayView extends DiamondNode {
  getShape() {
    const { model } = this.props;
    const { x, y, rx, ry } = model;
    void model.properties.__tv; // MobX: re-render on theme change
    const style = model.getNodeStyle();
    const points = `${x},${y - ry} ${x + rx},${y} ${x},${y + ry} ${x - rx},${y}`;

    return h('g', {}, [
      h('polygon', {
        points,
        ...style,
      }),
      // + marker (BPMN standard for Parallel Gateway)
      h('path', {
        d: `M ${x} ${y - 10} L ${x} ${y + 10} M ${x - 10} ${y} L ${x + 10} ${y}`,
        stroke: style.stroke,
        strokeWidth: 3,
        fill: 'none',
      }),
    ]);
  }
}

class ParallelGatewayModel extends DiamondNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 30;
    this.ry = 30;
    initLabelOffset(this, data, this.ry + 18);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'parallelGateway');
    style.stroke = t.stroke || '#13c2c2';
    style.strokeWidth = t.strokeWidth ?? 2;
    style.fill = t.fill || '#e6fffb';
    return style;
  }
}

export const ParallelGateway = {
  type: 'epx:ParallelGateway',
  view: ParallelGatewayView,
  model: ParallelGatewayModel,
};
